import moment from "moment-timezone";
import { getDateTokens } from "./dateFormat";

// LSP-15050: org-level date-format preference. The current org's choice ("MDY" US month-first or
// "DMY" UK day-first) is seeded by api.getMe()/refreshMe() via setDateFormat below, so any display
// date that flows through formatDate() without an explicit format follows the org setting. The
// actual moment format strings live in one place (dateFormat.ts getDateTokens) — we only hold the
// current key here and let getDateTokens own both the mapping and the unknown-value fallback.
let currentDateFormat = "MDY";

let timezones = {
	get defaultDateFormat() {
		return getDateTokens(currentDateFormat).dateShortPadded;
	},
	setDateFormat: function (format) {
		currentDateFormat = format || "MDY";
	},
	getDateFormat: function () {
		return currentDateFormat;
	},
	getTimezones: function () {
		const zones = [];
		const countries = moment.tz.countries();

		for (const country of countries) {
			moment.tz.zonesForCountry(country).reduce((set, zone) => zones.push(zone));
		}
		return zones;
	},
	guess: function () {
		let tz = moment.tz.guess();
		// console.log(tz)
		let allTz = this.getTimezones();
		// console.log(allTz)
		if (allTz.indexOf(tz) > -1) {
			// console.log('hit')
			return tz;
		}
		if (allTz.indexOf("America/New_York") > -1) {
			return "America/New_York";
		}
		return allTz[0];
	},
	formatDate: function (value, format) {
		if (value) {
			// LSP-19482: one date-time style. This default used the numeric dateTimeZ
			// ("09/02/2026 11:34 PM EDT") while the same value read "Sep 2 2026" in list columns and
			// "Wed, Sep 2 2026 11:34 PM" in the detail header. It now builds on the same short date
			// every other surface uses, keeping the zone suffix this format has always carried.
			const tokens = getDateTokens(currentDateFormat);
			const effectiveFormat = format || `${tokens.dateShortMonth} h:mm A z`;
			// TODO: i18n
			return moment.tz(String(value), "YYYY-MM-DD HH:mm:ss.SSS ZZ", moment.tz.guess()).format(effectiveFormat);
		}
	},
	formatDateOnlyLong: function (value) {
		if (value) {
			return moment
				.tz(String(value), "YYYY-MM-DD HH:mm:ss.SSS ZZ", moment.tz.guess())
				.format(getDateTokens(currentDateFormat).dateLong);
		}
	},
	formatDateWithDayOfWeek: function (value) {
		if (value) {
			return moment
				.tz(String(value), "YYYY-MM-DD HH:mm:ss.SSS ZZ", moment.tz.guess())
				.format(getDateTokens(currentDateFormat).dateLongWithWeekday);
		}
	},
	formatDateWithDayOfWeekShort: function (value) {
		if (value) {
			return moment
				.tz(String(value), "YYYY-MM-DD HH:mm:ss.SSS ZZ", moment.tz.guess())
				.format(getDateTokens(currentDateFormat).dateShortMonthWithWeekday);
		}
	},
	formatDateOnlyShort: function (value) {
		if (value) {
			// TODO: i18n
			return moment
				.tz(String(value), "YYYY-MM-DD HH:mm:ss.SSS ZZ", moment.tz.guess())
				.format(getDateTokens(currentDateFormat).dateShortMonthCommaYear);
		}
	},
	formatTimeOnly: function (value) {
		if (value) {
			return moment.tz(String(value), "YYYY-MM-DD HH:mm:ss.SSS ZZ", moment.tz.guess()).format("h:mm A");
		}
	}
};
export default timezones;
